import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/common";
import { Loader2, Thermometer } from "lucide-react";

function fmt(dtiso) {
  if (!dtiso) return "—";
  try { return new Date(dtiso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return dtiso; }
}

export default function TemperaturPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/temperature/overview").then((r) => { setRows(r.data); setLoading(false); });
  }, []);

  return (
    <div>
      <PageHeader title="Temperaturkontrolle" subtitle="Kühl-/Gefriergeräte & Fritteusen mit Grenzwerten" />
      {loading ? (
        <div className="flex items-center gap-2 text-slate-500 py-12 justify-center"><Loader2 className="h-5 w-5 animate-spin" /> Laden …</div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {rows.map((r) => (
            <div key={r.task_id} className="rounded-xl border border-slate-200 bg-white p-4" data-testid="temp-card">
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-semibold text-slate-800 text-sm">{r.object_name}</div>
                  <div className="text-xs text-slate-500">{r.room_name}</div>
                </div>
                <Thermometer className="h-5 w-5 text-teal-500" />
              </div>
              <div className="mt-3 flex items-end justify-between">
                <div>
                  <div className="font-mono text-2xl font-bold text-slate-900">
                    {r.last_temp != null ? `${r.last_temp}°` : "—"}
                  </div>
                  <div className="text-xs text-slate-400">{fmt(r.last_at)}</div>
                </div>
                <div className="text-right space-y-1">
                  <StatusBadge variant="teal">max. {r.temp_limit}°C</StatusBadge>
                  <div>
                    {r.last_temp == null ? (
                      <StatusBadge variant="neutral">keine Messung</StatusBadge>
                    ) : r.last_exceeded ? (
                      <StatusBadge variant="warning">überschritten</StatusBadge>
                    ) : (
                      <StatusBadge variant="done">im Sollbereich</StatusBadge>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
